import { useId } from "react";

import styles from "./Spinner.module.css";

/** A small gradient arc. Decorative: pair it with text or aria-busy for screen readers. */
export function Spinner({ size = 18 }: { size?: number }) {
  const gradient = useId();
  return (
    <svg
      className={styles.spinner}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradient} x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="currentColor" stopOpacity="1" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.1" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.15" strokeWidth="3" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke={`url(#${gradient})`}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
